module.exports = __webpack_public_path__ + "img/7da1fbe.svg";